import React from 'react'

import { animalColorUiTheme } from 'global'
import { IHand } from 'models'
import {
  Flex,
  Heading,
  Text,
  AnimalCard,
  ICardOuterFrameProps,
} from 'components'

interface IGoodForOneOrgasmCard extends ICardOuterFrameProps {
  handColor: IHand['color']
  animal: IHand['animal']
  flipAnimal?: boolean
  title?: string
  subTitle?: string
}

export const GoodForOneOrgasmCard = ({
  handColor,
  animal,
  flipAnimal = false,
  title,
  subTitle,
  ...props
}: IGoodForOneOrgasmCard) => {
  const uiTheme = animalColorUiTheme(handColor)
  return (
    <AnimalCard
      animal={animal}
      handColor={handColor}
      flipIcon={flipAnimal}
      {...props}
    >
      {() => (
        <Flex
          width='100%'
          height='100%'
          flexDirection='column'
          justifyContent='flex-start'
          alignItems='center'
        >
          <Heading
            as='h2'
            fontSize='34px'
            fontWeight={800}
            textAlign='center'
            margin={1}
            uiColorTheme={uiTheme}
          >
            {title || 'Good for one orgasm'}
          </Heading>
          <Text marginTop={2} uiColorTheme={uiTheme}>
            {subTitle || '(OR MORE)'}
          </Text>
        </Flex>
      )}
    </AnimalCard>
  )
}
